import { render, staticRenderFns } from "./tab-quote-details-compiled.vue?vue&type=template&id=6bd40f7c"
import script from "./tab-quote-details-compiled.vue?vue&type=script&lang=js"
export * from "./tab-quote-details-compiled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports